export default "__VITE_ASSET__BbXASh_O__"